/**
 * ПРАВИЛА НИКНЕЙМА — единственный источник правды.
 *
 * Конфиг общий для клиента и сервера: экран первичного выбора имени
 * (UserNamePage), админская смена никнейма (ChangeNicknamePage) и серверные
 * ручки проверяют одно и то же одними и теми же текстами ошибок. Раньше
 * правила были продублированы в двух местах и уже разъехались: в серверном
 * тексте ошибки не было сказано про знак подчеркивания, хотя регулярка его
 * разрешает.
 *
 * Занятость никнейма здесь НЕ проверяется — это запрос к базе, он живет на
 * сервере (см. ручки смены имени и завершения онбординга).
 */

export const NICKNAME_REGEX = /^[a-zA-Zа-яА-ЯёЁ0-9_]+$/;
export const MAX_NICKNAME_LENGTH = 20;

/**
 * @param {string} name - никнейм, уже обрезанный по краям (trim)
 * @returns {string|null} текст ошибки или null, если имя годится
 */
export const getNicknameError = (name) => {
  if (!name) {
    return 'Никнейм обязателен';
  }
  if (name.length > MAX_NICKNAME_LENGTH) {
    return `Никнейм не должен превышать ${MAX_NICKNAME_LENGTH} символов`;
  }
  if (!NICKNAME_REGEX.test(name)) {
    return 'Никнейм может содержать только латиницу, кириллицу, цифры и знак подчеркивания';
  }
  return null;
};
